export default __webpack_public_path__ + "static/media/rub.b435706c.svg";